import { useEffect } from 'react';

import { InstitutionOnboardingProgressStep, useProgress } from '@/context/progress';
import ForbiddenJurisdiction from '@/features/forbidden-jurisdiction/components/forbidden-jurisdiction';
import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionOnboardingIncorporationForbiddenJurisdictionPage = () => {
  const { setCurrentStep } = useProgress();

  useEffect(() => {
    return setCurrentStep(InstitutionOnboardingProgressStep.INSTITUTION_INFORMATION, 1);
  }, [setCurrentStep]);

  return (
    <InstitutionDetailsLayout className="-md:justify-center space-y-8" detailsKey="incorporation" detailsType={INSTITUTION_DETAILS_TYPE.ONBOARDING} size="sm">
      <ForbiddenJurisdiction />
    </InstitutionDetailsLayout>
  );
};
InstitutionOnboardingIncorporationForbiddenJurisdictionPage.displayName = 'InstitutionOnboardingIncorporationForbiddenJurisdictionPage';

export default InstitutionOnboardingIncorporationForbiddenJurisdictionPage;
